export default __webpack_public_path__ + "static/media/Plus.bfe12e6c.svg";